import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import { axiosClient } from "@api/clients.ts";
import type { IStaffProfileStatisticsEndpoint } from "@api/system/staffProfileStatistics/types";
import type { IApiResponse } from "@/api";

const { key, getPath } = getApi("system.staffProfileStatistics.get");

const getStaffProfileStatistics: Fetcher<
  IApiResponse<IStaffProfileStatisticsEndpoint>
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetStaffProfileStatistics = createQuery({
  queryKey: [key],
  fetcher: getStaffProfileStatistics,
});
